import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { firebaseReady, waitForObserverAuth } from "../services/firebaseAuth";
import {
  deleteResearchItem,
  loadResearchLibrary,
  saveResearchItem,
} from "../services/researchLibrary";
import { trackAnalyticsEvent } from "../services/analytics";

export default function SaveToLibraryButton({ entityId }: { entityId: string }) {
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!firebaseReady) return;
    void waitForObserverAuth().then((user) => {
      if (!user) return;
      return loadResearchLibrary()
        .then((library) => setSaved(library.items.some((item) => item.entityId === entityId)))
        .catch(() => {});
    });
  }, [entityId]);

  const toggle = async () => {
    const user = firebaseReady ? await waitForObserverAuth() : null;
    if (!user) {
      navigate(`/sign-in?returnTo=${encodeURIComponent(window.location.pathname)}`);
      return;
    }
    setBusy(true);
    setNotice("");
    try {
      if (saved) {
        await deleteResearchItem(entityId);
        setSaved(false);
        setNotice("Removed from your private Library.");
      } else {
        await saveResearchItem(entityId);
        setSaved(true);
        setNotice("Saved privately. Add notes from Library.");
        trackAnalyticsEvent("profile_saved", { placement: "profile" });
      }
    } catch (reason) {
      setNotice((reason as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ margin: "20px 0" }}>
      <button className="button button-ink" disabled={busy} onClick={toggle}>
        {busy ? "Updating…" : saved ? "Remove from Library" : "Save to private Library"}
      </button>
      {notice && <p role="status" style={{ color: "#52615a", margin: "8px 0 0" }}>{notice}</p>}
    </div>
  );
}
